{
  "dirty": false,
  "raw": "8df598f",
  "hash": "8df598f",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "8df598f",
  "semverString": null
}